import { useState } from "react";
import { accountService, homeService, taskService } from "@miplatform/api";
import { HOME_PHASE, HTTP_STATUSES, ORDER_TYPES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { getHomePhase } from "../../utils/getHomePhase/getHomePhase";

const HOME_PHASE_MAP = {
  [HOME_PHASE.UNDER_CONSTRUCTION]: {
    activeTab: ORDER_TYPES.UNDER_CONSTRUCTION,
    enabledTabs: [ORDER_TYPES.UNDER_CONSTRUCTION, ORDER_TYPES.SERVICE],
  },
  [HOME_PHASE.UNDER_WARRANTY]: {
    activeTab: ORDER_TYPES.UNDER_WARRANTY,
    enabledTabs: [ORDER_TYPES.UNDER_WARRANTY, ORDER_TYPES.SERVICE],
  },
  [HOME_PHASE.OUT_OF_WARRANTY]: {
    activeTab: ORDER_TYPES.SERVICE,
    enabledTabs: [ORDER_TYPES.SERVICE],
  },
};

export const useOrderTemplateSelectionViewModel = ({
  homeId,
  defaultActiveTab,
}) => {
  const [orderTemplates, setOrderTemplates] = useState([]);
  const [homeOrders, setHomeOrders] = useState([]);
  const [homeDetails, setHomeDetails] = useState();
  const [activeMainTab, setActiveMainTab] = useState("Order Creation");
  const [activeOrderCreationTab, setActiveOrderCreationTab] = useState("");
  const [homeBuilderDetails, setHomeBuilderDetails] = useState(null);

  const stateManager = useComponentState();

  const loadAllOrderTemplates = () => {
    stateManager.run(async () => {
      const { status, data } = await taskService.orderTemplates.getAllCreatable(
        { filters: { isActive: true } }
      );
      if (status === HTTP_STATUSES.OK) {
        setOrderTemplates(data);
      }
    });
  };

  const getHomeOrders = () => {
    stateManager.run(async () => {
      const { status, data } = await taskService.order.getAll({
        filters: { homeId: { type: "guid", value: homeId } },
      });
      if (status === HTTP_STATUSES.OK) {
        setHomeOrders(data);
      }
    });
  };

  const getHomeBuilderDetails = (builderId) => {
    stateManager.run(async () => {
      const { status, data: builder } =
        await accountService.accounts.getAccountById({
          id: builderId,
        });
      if (status === HTTP_STATUSES.OK) {
        setHomeBuilderDetails(builder);
      }
    });
  };

  const updateHome = (updatedHome) => {
    stateManager.run(async () => {
      const { status, data: home } = await homeService.homes.update({
        id: homeId,
        data: { ...updatedHome, modifiedOn: homeDetails.modifiedOn },
      });
      if (status === HTTP_STATUSES.OK) {
        setHomeDetails(home);
        const homePhase = getHomePhase(home);
        setActiveOrderCreationTab(HOME_PHASE_MAP[homePhase].activeTab);
      }
    });
  };

  const getHomeDetails = () => {
    stateManager.run(async () => {
      const { status, data: home } = await homeService.homes.getById({
        id: homeId,
      });
      if (status === HTTP_STATUSES.OK) {
        setHomeDetails(home);
        if (home.builderId) {
          getHomeBuilderDetails(home.builderId);
        }
        const homePhase = getHomePhase(home);
        setActiveOrderCreationTab(
          defaultActiveTab || HOME_PHASE_MAP[homePhase].activeTab
        );
      }
    });
  };

  return {
    HOME_PHASE_MAP,
    isLoading: stateManager.isBusy(),
    orderTemplates,
    homeOrders,
    homeDetails,
    activeOrderCreationTab,
    activeMainTab,
    homeBuilderDetails,
    updateHome,
    setActiveMainTab,
    setActiveOrderCreationTab,
    getHomeDetails,
    loadAllOrderTemplates,
    getHomeOrders,
  };
};
